/**
 * Mirror backend currencyToVariantMethodId (zeroxCoinCatalogUtils.js).
 * Maps static wallet currency labels to fee-config method ids.
 */
export function currencyToZeroxMethodId(currencyRaw: string | null | undefined): string {
  const currency = String(currencyRaw || '').trim().toLowerCase();
  if (!currency) return 'all';
  const normalized = currency
    .replace(/[()]/g, ' ')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
  return normalized ? `zerox_${normalized}` : 'all';
}

export function zeroxMethodIdFromStaticWallet(
  wallet: { currency?: string | null } | null | undefined
): string {
  if (!wallet) return 'all';
  return currencyToZeroxMethodId(wallet.currency);
}

/** Allowed 0x method ids for "Deposit to USD wallet" (Pay with Crypto tab). */
export const USD_DEPOSIT_ZEROX_METHOD_IDS = ['zerox_eth', 'zerox_usdt_erc20'] as const;

export function isUsdDepositZeroxMethodId(methodId: string | null | undefined): boolean {
  const id = String(methodId || '').trim().toLowerCase();
  return (USD_DEPOSIT_ZEROX_METHOD_IDS as readonly string[]).includes(id);
}

export function filterUsdDepositStaticWallets<T extends { currency?: string | null }>(
  wallets: T[]
): T[] {
  return wallets.filter((w) => isUsdDepositZeroxMethodId(zeroxMethodIdFromStaticWallet(w)));
}
